
window.addEventListener('load', function (event) {
    const videoBannerDateElem = document.querySelector('.videoBanner__date');
    if (document.querySelectorAll(".videoBanner").length > 0) videoRemovalInit();

    if (videoBannerDateElem) {
        const setVideoDate = () => {
            const videoDate = new LocalDate('Europe/London', 'London', videoBannerDateElem);
            videoDate.setDate();

            videoBannerDateElem.classList.add('videoBanner__date_fadeIn');

        }
    
        setInterval(setVideoDate, 1000);

    }
});

function addClass() {
    const body = document.body;
    body.classList.add("js--hide-video");
}

function removeClass() {
    const body = document.body;
    body.classList.remove("js--hide-video");
}

function videoRemovalInit() {

    const viewPortWidth = window.innerWidth || document.documentElement.clientWidth;

    document.addEventListener('scroll', (event) => {
        if (document.documentElement.scrollTop > 1400 && viewPortWidth < 991) {
            addClass()
        }
        else {
            removeClass();
        }
    });
}

class LocalDate {
    constructor(dateLocale, locationText, element) {
        this._localDateElem = element;
        this._dateLocale = dateLocale;
        this._locationText = locationText;
        this._currentDate = new Date();
        this._date = this._currentDate.toLocaleDateString('en-GB').replaceAll('/', '.');
        this._time = this._currentDate.toLocaleTimeString('en-GB', {
            timeZone: this._dateLocale,
            hour: '2-digit',
            minute: '2-digit'
        }).replaceAll(',', '');
    }

    setDate() {
        if (this._localDateElem) {
            this._localDateElem.innerHTML = `${this._locationText} ${this._time} ${this._date}`;
        }
    }
}